import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import {
  ADMIN_ALLOWED_URLS,
  EMPLOYEE_ALLOWED_URLS,
} from '../shared/constants/constants';
import { StorageKeys, UserRoles } from '../shared/enums/enums';
import { AuthService } from '../shared/services/auth.service';
import { StorageService } from '../shared/services/storage.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  const isTokenValid = await checkAuthTokenValidity(
    storageService.getItem(StorageKeys.authTokens)
  );
  if (!state.url.includes('/login')) {
    if (isTokenValid) {
      if (
        storageService.getItem(StorageKeys.userRole) === UserRoles.EMPLOYEE &&
        !EMPLOYEE_ALLOWED_URLS.includes(state.url)
      ) {
        router.navigate(['/videos']);
        return false;
      } else if (
        storageService.getItem(StorageKeys.userRole) === UserRoles.ADMIN &&
        !ADMIN_ALLOWED_URLS.filter((path) => {
          if (path === '/') {
            return path === state.url;
          } else {
            return state.url.includes(path);
          }
        }).length
      ) {
        router.navigate(['/']);
        return false;
      } else {
        return true;
      }
    } else {
      router.navigate(['/login']);
      return false;
    }
  } else {
    if (isTokenValid) {
      if (storageService.getItem(StorageKeys.userRole) === UserRoles.EMPLOYEE) {
        router.navigate(['/videos']);
      } else {
        router.navigate(['/']);
      }
      return false;
    } else {
      return true;
    }
  }
};

const fetchRefreshToken = (refreshToken: string) => {
  const authService = inject(AuthService);
  const storageService = inject(StorageService);
  return new Promise((resolve, reject) => {
    authService.refreshToken({ refreshToken }).subscribe({
      next: (res) => {
        storageService.setItem(StorageKeys.authTokens, res);
        resolve(res);
      },
      error(err) {
        reject(err);
      },
    });
  });
};

const checkAuthTokenValidity = async (authTokens: any) => {
  if (authTokens) {
    const { accessToken, refreshToken } = authTokens;
    const accessTokenExp = (jwtDecode(accessToken).exp || 0) * 1000;
    const refreshTokenExp = (jwtDecode(refreshToken).exp || 0) * 1000;
    if (accessTokenExp > Date.now()) {
      return true;
    } else if (refreshTokenExp < Date.now()) {
      await fetchRefreshToken(refreshToken);
      return true;
    }
  }
  return false;
};
